import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import { renderReferenceRichText } from './reference-section-helpers';

export default function ReferenceSolutionSection({ blok }) {
  if (!blok?.title && !blok?.text) {
    return null;
  }

  return (
    <section
      {...storyblokEditable(blok)}
      className="pt-12 pb-16 lg:pt-20 lg:pb-24"
    >
      <Container>
        {blok?.title && (
          <FancyTitle
            text={blok.title}
            tag={blok?.title_tag || 'h3'}
            textAlign="text-left"
            marginBottom="mb-6"
          />
        )}
        {renderReferenceRichText(blok?.text, 'text-[16px] leading-[24px]')}
      </Container>
    </section>
  );
}
